import Layout from "@/components/layout/layout";
import StaffQuestionManager from "../components/mini-game/manage-question";

const ManageGamePage = () => {
  return (
    <div>
      <Layout>
        <StaffQuestionManager />
      </Layout>
    </div>
  );
};

export default ManageGamePage;
